<template>
  <div style="width: 100vw;height: 100vh">
    <router-view/>
    <record-number :title="'南京木鱼智能科技有限公司'" :recordnumber="'苏ICP备19067306号-1'"></record-number>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue